import { Component, inject } from '@angular/core';
import { FwButtonComponent, FwLayoutContextComponent } from '@flywheel-io/vision';

import { AuthService } from '../auth.service';

@Component({
  selector: 'app-account-deactivated',
  imports: [FwLayoutContextComponent, FwButtonComponent],
  template: `
    <fw-layout-context
      description="Your account has been deactivated. Please contact your administrator for more information."
      icon="lock"
      title="Account Deactivated"
    >
      <fw-button leftIcon="rotate-refresh" variant="outline" (click)="auth.login()">Return to Login</fw-button>
    </fw-layout-context>
  `,
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100vh;
        width: 100vw;
      }
    `,
  ],
})
export class AccountDeactivatedComponent {
  protected auth = inject(AuthService);
}
